import { Injectable } from "@angular/core";
import { PublicHttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class PublicImssService {
  constructor(private publicHttp: PublicHttpClientService) {}

  public request_nss(person_id): Observable<any> {
    const options = {
      person_id: person_id,
    };
    return this.publicHttp
      .post("/api/public/imss", options)
      .pipe(tap((_) => console.log("ImssService.request_nss: Ok.")));
  }

  public request_sdk_token(): Observable<any> {
    return this.publicHttp
      .post("/api/imss/sdk_token", null)
      .pipe(tap((_) => console.log("PublicImssService.request_sdk_token: Ok.")));
  }
}
